<app-settings-sub-header
    [informateForm]="informateSettingsForm"
    [headerData]="subHeaderData"
    [isSaveEnabled]="isSaveEnabled"
    (saveSettingsOutput)="saveSettingsOutputHandler($event)"
    (saveInstanceSettingsOutput)="saveInstanceSettingsOutputHandler($event)"
></app-settings-sub-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <mat-tab-group class="tab-wrapper">
                        <mat-tab label="{{ 'SETTING_PAGE.INFORMATE_SETTINGS.TABS.DEFAULTS' | transloco }}" *ngIf="viewUserDefults === true">
                            <ng-template matTabContent>
                                <app-default-units [form]="informateSettingsForm" [dataSource]="defaultUnitSettings"></app-default-units>
                            </ng-template>
                        </mat-tab>
                        <mat-tab
                            label="{{ 'SETTING_PAGE.INFORMATE_SETTINGS.TABS.CALCULATION_PREFERENCES' | transloco }}"
                            *ngIf="viewCalculationPreference == true"
                        >
                            <ng-template matTabContent>
                                <app-calculation-preferences
                                    [form]="informateSettingsForm"
                                    [dataSource]="calculationPreferenceSettings"
                                ></app-calculation-preferences>
                            </ng-template>
                        </mat-tab>
                        <!-- *********** Hiding this tab as per story no : 6392  -->
                        <!-- <mat-tab label="{{'SETTING_PAGE.INFORMATE_SETTINGS.TABS.INSTANCE_CONFIGURATION' | transloco}}" *ngIf="isInstanceConfAllowed && curInstanceId ">

              <ng-template matTabContent>

                <app-instance-configuration [saveAllowedItems]="saveAllowedItems"  (enableSaveButton)="enableSaveButtonHandler($event)"></app-instance-configuration>

              </ng-template>

            </mat-tab> -->
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
</div>
